"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setCookie = setCookie;
exports.getCookie = getCookie;
exports.hasAffiliateCookie = hasAffiliateCookie;

var _slice = _interopRequireDefault(require("lodash/slice"));

/**
 * Set cookie on path=/
 *
 * @static
 * @param {string} key
 * @param {string} value
 * @param {number} days
 *
 * @memberOf CookieHelper
 */
function setCookie(key, value) {
  var days = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var cookieDomain = '';
  var expiryDate = new Date();
  expiryDate.setTime(expiryDate.getTime() + days * 24 * 60 * 60 * 1000);
  var expireDate = days ? ";expires=".concat(expiryDate.toUTCString()) : '';

  if (process.env.isProd) {
    var host = window.location.host.split('.');
    var hostName = (0, _slice["default"])(host, 1, host.length).join('.');
    cookieDomain = ";domain=.".concat(hostName);
  }

  window.document.cookie = "".concat(key, "=").concat(value).concat(expireDate, ";SameSite=None; Secure;path=/").concat(cookieDomain);
}
/**
 * Get cookie form key
 *
 * @function
 * @param {any} key
 * @returns {string} value
 *
 * @memberOf CookieHelper
 */


function getCookie(key) {
  var value = '; ' + document.cookie;
  var parts = value.split('; ' + key + '=');

  if (parts.length === 2) {
    return parts.pop().split(';').shift();
  }
}

function hasAffiliateCookie() {
  return !!getCookie('FRT:VIS') || !!getCookie('ir.mid');
}